<div class="floating-label">
    <textarea
        [formControlName]="controlName"
        class="textarea-resize-none"
        [rows]="rows"
        [cols]="cols"
        [attr.placeholder]="placeholderText | translate"
        [ngClass]="{ 'no-icon': !showIcon }"
        autocomplete="off">
    </textarea>
    <label-extended-control [labelText]="labelText"></label-extended-control>
    <div *ngIf="showIcon" class="icon">
        <span [class]="iconClass"></span>
    </div>
    <field-error-display-control
        [displayError]="parentFormHelper.showFieldError(controlName)"
        [errorMsg]="parentFormHelper.getErrorMessageHtml(controlName)">
    </field-error-display-control>
</div>
